import React, { Component } from 'react';
import { Route } from 'react-router';
import { Layout } from './components/AppLayout';
import { FetchData } from './components/FetchData';
import AuthorizeRoute from './components/api-authorization/AuthorizeRoute';
import ApiAuthorizationRoutes from './components/api-authorization/ApiAuthorizationRoutes';
import { ApplicationPaths } from './components/api-authorization/ApiAuthorizationConstants';
import PortalHome from './components/PortalHome';
import F7Submission from './components/F7Submission';
import ReferralSubmission from './components/ReferralSubmission';
import RequestSubmission from './components/RequestSubmission';
import RequestDetails from './components/RequestDetails';
import Profile from './components/Profile';
import Contract from './components/Contract';
import VerifyLink from './components/LinkVerification';
import PublicF7 from './components/F7GuestSubmission';
//import Public8G from './components/8GGuestSubmission';
import './custom.css';

export default class App extends Component {
  static displayName = App.name;

  render () {
    return (
      <Layout>
            <AuthorizeRoute exact path='/' component={VerifyLink} />
            <AuthorizeRoute path='/Home' component={PortalHome} />
            {/*<AuthorizeRoute exact path='/' component={PortalHome} />*/}
            <AuthorizeRoute path="/Verify" component={VerifyLink} />
            <AuthorizeRoute path='/F7Submission' component={F7Submission} />
            <AuthorizeRoute path='/ReferralSubmission' component={ReferralSubmission} />
            <AuthorizeRoute path='/RequestDetails' component={RequestDetails} />
            <AuthorizeRoute path='/RequestSubmission' component={RequestSubmission} />
            <AuthorizeRoute path='/Profile' component={Profile} />
            <AuthorizeRoute path='/Contract' component={Contract} />
            <AuthorizeRoute path='/fetch-data' component={FetchData} />
            <Route path='/Public/F7' component={PublicF7}/>
            {/*<Route path='/Public/8G' component={Public8G}/>*/}
            <Route path={ApplicationPaths.ApiAuthorizationPrefix} component={ApiAuthorizationRoutes} />
      </Layout>
    );
  }
}
